module.exports = __webpack_public_path__ + "img/icon-dapp-ensmanager.3a89df85.svg";